import type { LoaderFunction, MetaFunction } from '@remix-run/node';
import { useLoaderData, useRouteLoaderData } from '@remix-run/react';

import StaticPage from '~/components/StaticPage';
import { staticPageClientLoader } from '~/components/StaticPage/staticPageClientLoader';
import type { RootLoaderData } from '~/root';
import { staticPageLoader } from '~/services/static_page';
import { findTipTapContentNode } from '~/utils/findTipTapContentNode';
import getStaticPageMetaData from '~/utils/getStaticPageMetaData';
import { shouldRevalidateLoaderData } from '~/utils/shouldRevalidateLoaderData';

export const meta: MetaFunction<typeof loader> = (args) => {
  const { data } = args;

  let surveyName = null;
  let surveyDescription = null;

  if (data?.page?.viewable_page_version?.content) {
    const surveyNode = findTipTapContentNode(data.page.viewable_page_version.content, 'survey');
    if (surveyNode?.attrs?.data?.title) {
      surveyName = surveyNode.attrs.data.title;
    }
    if (surveyNode?.attrs?.data?.description) {
      surveyDescription = surveyNode.attrs.data.description;
    }
  }

  const overrideData = {
    title: surveyName,
    description: surveyDescription,
  };

  return getStaticPageMetaData(args, overrideData);
};

export const loader: LoaderFunction = async ({ request, params, context }) => {
  const formId = params?.formId;

  return staticPageLoader({
    request,
    context,
    pageRequestParams: {
      pathname: 'forms/$id',
      formId,
    },
  });
};

export const clientLoader = staticPageClientLoader;

const PublicationForm = () => {
  const { page } = useLoaderData<typeof loader>();
  const { site } = useRouteLoaderData('root') as RootLoaderData;

  return <StaticPage page={page} site={site} />;
};

export const shouldRevalidate = shouldRevalidateLoaderData;

export default PublicationForm;
